export var WidgetPosition;
(function (WidgetPosition) {
    WidgetPosition[WidgetPosition["LEFT"] = 10] = "LEFT";
    WidgetPosition[WidgetPosition["RIGHT"] = 20] = "RIGHT";
})(WidgetPosition || (WidgetPosition = {}));
export var WidgetModuleTransition;
(function (WidgetModuleTransition) {
    WidgetModuleTransition[WidgetModuleTransition["FLIP"] = 10] = "FLIP";
    WidgetModuleTransition[WidgetModuleTransition["VERTICAL"] = 20] = "VERTICAL";
})(WidgetModuleTransition || (WidgetModuleTransition = {}));
//# sourceMappingURL=widget-appearance-settings.i.js.map